import './Delivery.css';
import DeliveryImg from '../../../assets/img3D GIRL.png'

function Delivery(){

  return(

    <>
     <div className="boxDelivery">
   <div><img src={DeliveryImg}/></div>  
    <div className='boxDeliveryDetails'>
    <h4>توصيل سريع</h4>
    
    <p style={{fontWeight: 'bold',margin:0}}>اعرف اكتر </p>
    </div>
    
    <a href="#"><i class="fa-solid fa-arrow-left"></i></a>
</div>
    
    
    
    
    
    
    
    
    </>
  )





}
export default Delivery